(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wishlist-engine"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.AmbientWishlist) {
      window.AmbientWishlist.refresh(document);
      return;
    }

    const storageKey = 'ambient_home_wishlist_v1';
    const wishlistIdKey = 'ambient_home_wishlist_id_v1';
    const attributionSessionKey = 'ambient_home_wishlist_cart_signature_v1';
    const attributionActiveKey = 'ambient_home_wishlist_cart_active_v1';
    const maximumItems = 100;
    let memoryWishlistId = '';
    let memoryItems = [];
    let attributionTimer;
    let toastTimer;

    const sanitizeString = (value) => String(value || '').trim();
    const sanitizeNumber = (value) => {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    };

    const sanitizeItem = (item) => {
      const handle = sanitizeString(item?.handle);
      if (!handle) return null;

      return {
        handle,
        productId: sanitizeNumber(item.productId),
        title: sanitizeString(item.title),
        url: sanitizeString(item.url),
        image: sanitizeString(item.image),
        price: sanitizeNumber(item.price),
        compareAtPrice: sanitizeNumber(item.compareAtPrice),
        variantId: sanitizeNumber(item.variantId),
        currency: sanitizeString(item.currency),
        available: item.available !== false,
        vendor: sanitizeString(item.vendor),
        description: sanitizeString(item.description),
        addedAt: sanitizeNumber(item.addedAt) || Date.now()
      };
    };

    const readItems = () => {
      try {
        const storedValue = window.localStorage.getItem(storageKey);
        if (!storedValue) return memoryItems.slice();
        const parsedValue = JSON.parse(storedValue);
        const sourceItems = Array.isArray(parsedValue) ? parsedValue : parsedValue?.items;
        if (!Array.isArray(sourceItems)) return memoryItems.slice();
        const uniqueItems = new Map();
        sourceItems.forEach((item) => {
          const sanitizedItem = sanitizeItem(item);
          if (sanitizedItem && !uniqueItems.has(sanitizedItem.handle)) {
            uniqueItems.set(sanitizedItem.handle, sanitizedItem);
          }
        });
        memoryItems = Array.from(uniqueItems.values()).slice(0, maximumItems);
      } catch (error) {
        return memoryItems.slice();
      }
      return memoryItems.slice();
    };

    const writeItems = (items) => {
      memoryItems = items
        .map(sanitizeItem)
        .filter(Boolean)
        .slice(0, maximumItems);

      try {
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            version: 1,
            items: memoryItems
          })
        );
      } catch (error) {
        memoryItems = memoryItems.slice();
      }
    };

    const itemFromButton = (button) => ({
      handle: button.dataset.productHandle,
      productId: button.dataset.productId,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      compareAtPrice: button.dataset.productCompareAtPrice,
      variantId: button.dataset.productVariantId,
      available: button.dataset.productAvailable !== 'false',
      vendor: button.dataset.productVendor,
      description: button.dataset.productDescription,
      currency: button.dataset.productCurrency,
      addedAt: Date.now()
    });

    const activeCurrency = () =>
      sanitizeString(window.Shopify?.currency?.active) ||
      sanitizeString(document.documentElement.dataset.currency) ||
      'EUR';

    const createWishlistId = () => {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      return `ah_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
    };

    const getWishlistId = () => {
      if (memoryWishlistId) return memoryWishlistId;
      try {
        const storedId = sanitizeString(window.localStorage.getItem(wishlistIdKey));
        if (storedId) {
          memoryWishlistId = storedId;
          return memoryWishlistId;
        }
        const generatedId = createWishlistId();
        window.localStorage.setItem(wishlistIdKey, generatedId);
        memoryWishlistId = generatedId;
        return memoryWishlistId;
      } catch (error) {
        memoryWishlistId = createWishlistId();
        return memoryWishlistId;
      }
    };

    const analyticsItem = (item) => {
      const sanitizedItem = sanitizeItem(item);
      if (!sanitizedItem) return {};

      return {
        item_id: sanitizedItem.variantId ? String(sanitizedItem.variantId) : sanitizedItem.handle,
        product_id: sanitizedItem.productId ? String(sanitizedItem.productId) : '',
        product_handle: sanitizedItem.handle,
        product_title: sanitizedItem.title,
        product_vendor: sanitizedItem.vendor,
        variant_id: sanitizedItem.variantId ? String(sanitizedItem.variantId) : '',
        price: sanitizedItem.price / 100,
        currency: sanitizedItem.currency || activeCurrency()
      };
    };

    const track = (eventName, eventData = {}) => {
      const normalizedName = sanitizeString(eventName);
      if (!normalizedName) return;

      const payload = {
        tracking_version: 'wishlist-ga4-v5',
        wishlist_id: getWishlistId(),
        wishlist_size: readItems().length,
        page_path: window.location.pathname,
        ...eventData
      };

      try {
        window.Shopify?.analytics?.publish(`ambient_home:${normalizedName}`, payload);
      } catch (error) {
        // Le fonctionnement de la wishlist ne doit jamais dépendre du pixel.
      }

      document.dispatchEvent(
        new CustomEvent('ambient:wishlist:analytics', {
          detail: {
            name: normalizedName,
            data: payload
          }
        })
      );
    };

    const cartAttributionAttributes = (items) => {
      const variantIds = items
        .map((item) => sanitizeNumber(item.variantId))
        .filter(Boolean)
        .map(String)
        .slice(0, maximumItems);
      const productIds = items
        .map((item) => sanitizeNumber(item.productId))
        .filter(Boolean)
        .map(String)
        .slice(0, maximumItems);
      const attributes = {
        ah_wishlist_id: items.length > 0 ? getWishlistId() : '',
        ah_wishlist_size: items.length > 0 ? String(items.length) : ''
      };

      for (let index = 0; index < 10; index += 1) {
        attributes[`ah_wishlist_variant_ids_${index + 1}`] = variantIds
          .slice(index * 10, index * 10 + 10)
          .join(',');
        attributes[`ah_wishlist_product_ids_${index + 1}`] = productIds
          .slice(index * 10, index * 10 + 10)
          .join(',');
      }

      return attributes;
    };

    const syncCartAttribution = (items = readItems()) => {
      const attributes = cartAttributionAttributes(items);
      const signature = JSON.stringify(attributes);
      let attributionWasActive = false;

      try {
        attributionWasActive = window.localStorage.getItem(attributionActiveKey) === '1';
        if (items.length === 0 && !attributionWasActive) return;
        if (window.sessionStorage.getItem(attributionSessionKey) === signature) return;
      } catch (error) {
        if (items.length === 0) return;
      }

      window.clearTimeout(attributionTimer);
      attributionTimer = window.setTimeout(async () => {
        const root = sanitizeString(window.Shopify?.routes?.root) || '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

        try {
          const response = await fetch(`${normalizedRoot}cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            keepalive: true,
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) return;
          try {
            window.sessionStorage.setItem(attributionSessionKey, signature);
            if (items.length > 0) {
              window.localStorage.setItem(attributionActiveKey, '1');
            } else {
              window.localStorage.removeItem(attributionActiveKey);
            }
          } catch (error) {
            return;
          }
        } catch (error) {
          return;
        }
      }, 180);
    };

    const updateToggle = (button, items) => {
      const handle = sanitizeString(button.dataset.productHandle);
      if (!handle) return;
      const isActive = items.some((item) => item.handle === handle);
      const label = isActive
        ? button.dataset.labelRemove || ((window.AH_I18N && window.AH_I18N.wishlist_remove) || 'Retirer des favoris')
        : button.dataset.labelAdd || ((window.AH_I18N && window.AH_I18N.wishlist_add) || 'Ajouter aux favoris');

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);

      const hiddenLabel = button.querySelector('[data-ah-wishlist-label]');
      if (hiddenLabel) hiddenLabel.textContent = label;
    };

    const refresh = (root = document) => {
      const items = readItems();
      root.querySelectorAll('[data-ah-wishlist-toggle]').forEach((button) => {
        updateToggle(button, items);
      });

      document.querySelectorAll('[data-ah-wishlist-count]').forEach((counter) => {
        counter.textContent = String(items.length);
        counter.hidden = items.length === 0;
        counter.classList.toggle('is-double-digit', items.length >= 10 && items.length < 100);
        counter.classList.toggle('is-triple-digit', items.length >= 100);
      });

      document.querySelectorAll('[data-ah-wishlist-link]').forEach((link) => {
        const suffix = items.length === 1 ? ((window.AH_I18N && window.AH_I18N.wishlist_one_product) || '1 produit') : ((window.AH_I18N && window.AH_I18N.wishlist_n_products) || '{n} produits').replace('{n}', items.length);
        link.classList.toggle('has-items', items.length > 0);
        link.toggleAttribute('data-ah-wishlist-has-items', items.length > 0);
        link.setAttribute('aria-label', ((window.AH_I18N && window.AH_I18N.wishlist_link_label) || 'Mes favoris, {suffix}').replace('{suffix}', suffix));
      });
    };

    const notify = (message) => {
      const toast = document.querySelector('[data-ah-wishlist-toast]');
      if (!toast || !message) return;
      window.clearTimeout(toastTimer);
      toast.textContent = message;
      toast.hidden = false;
      window.requestAnimationFrame(() => toast.classList.add('is-visible'));
      toastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
        window.setTimeout(() => {
          toast.hidden = true;
        }, 200);
      }, 2400);
    };

    const emitChange = () => {
      const items = readItems();
      refresh(document);
      syncCartAttribution(items);
      document.dispatchEvent(
        new CustomEvent('ambient:wishlist:change', {
          detail: {
            items,
            count: items.length
          }
        })
      );
    };

    const add = (item, source = 'api') => {
      const sanitizedItem = sanitizeItem(item);
      if (!sanitizedItem) return false;
      const items = readItems().filter((currentItem) => currentItem.handle !== sanitizedItem.handle);
      items.unshift(sanitizedItem);
      writeItems(items);
      emitChange();
      track('wishlist_added', {
        wishlist_source: source,
        ...analyticsItem(sanitizedItem)
      });
      return true;
    };

    const remove = (handle, source = 'api') => {
      const normalizedHandle = sanitizeString(handle);
      const items = readItems();
      const removedItem = items.find((item) => item.handle === normalizedHandle);
      const nextItems = items.filter((item) => item.handle !== normalizedHandle);
      if (nextItems.length === items.length) return false;
      writeItems(nextItems);
      emitChange();
      track('wishlist_removed', {
        wishlist_source: source,
        ...analyticsItem(removedItem)
      });
      return true;
    };

    const clear = (source = 'wishlist_page') => {
      const items = readItems();
      if (items.length === 0) return;
      writeItems([]);
      emitChange();
      track('wishlist_cleared', {
        wishlist_source: source,
        previous_wishlist_size: items.length
      });
    };

    const has = (handle) => readItems().some((item) => item.handle === sanitizeString(handle));

    const toggle = (item, source = 'api') => {
      const sanitizedItem = sanitizeItem(item);
      if (!sanitizedItem) return false;
      if (has(sanitizedItem.handle)) {
        remove(sanitizedItem.handle, source);
        return false;
      }
      add(sanitizedItem, source);
      return true;
    };

    window.AmbientWishlist = {
      add,
      clear,
      count: () => readItems().length,
      getItems: readItems,
      getWishlistId,
      has,
      notify,
      refresh,
      remove,
      syncCartAttribution,
      toAnalyticsItem: analyticsItem,
      track,
      toggle
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ah-wishlist-toggle]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const source =
        sanitizeString(button.dataset.wishlistSource) ||
        (button.closest('ambient-wishlist-page')
          ? 'wishlist_page'
          : button.classList.contains('ah-wishlist-toggle--product')
            ? 'product_page'
            : 'product_card');
      const wasAdded = toggle(itemFromButton(button), source);
      const message = wasAdded
        ? button.dataset.messageAdd || ((window.AH_I18N && window.AH_I18N.wishlist_added) || 'Ajouté aux favoris')
        : button.dataset.messageRemove || ((window.AH_I18N && window.AH_I18N.wishlist_removed) || 'Retiré des favoris');
      notify(message);
    });

    document.addEventListener('shopify:section:load', (event) => {
      refresh(event.target);
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== storageKey) return;
      memoryItems = [];
      emitChange();
    });

    const initialize = () => {
      refresh(document);
      syncCartAttribution(readItems());
      document.dispatchEvent(new CustomEvent('ambient:wishlist:ready'));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
